import Vue from 'vue';
import Router from 'vue-router';

import TokenService from "../services/token.service";
import { apiFactory } from "../services/api";

import Dashboard from '../pages/Dashboard.vue';
import Social from '../pages/Social.vue';
import Media from '../pages/Media.vue';
import Snackbar from '../pages/Snackbar.vue';
import Chart from '../pages/Chart.vue';
import Mailbox from '../pages/Mailbox.vue';
import Calendar from '../pages/Calendar.vue';
import Login from '../pages/core/Login.vue';
import Register from '../pages/core/Register.vue';
import Error from '../pages/core/Error.vue';

import groups_add from '../pages/groups/add.vue';
import groups_edit from '../pages/groups/edit.vue';
import groups_list from '../pages/groups/list.vue';

import ServersAdd from '../pages/servers/add.vue';
import ServersEdit from '../pages/servers/edit.vue';
import ServersList from '../pages/servers/list.vue';
import ServersJobs from '../pages/servers/jobs.vue';

import instances_add from '../pages/instances/add.vue';
import instances_edit from '../pages/instances/edit.vue';
import instances_status from '../pages/instances/status.vue';
import instances_list from '../pages/instances/list.vue';
import instances_jobs from '../pages/instances/jobs.vue';

import projects_add from '../pages/projects/add.vue';
import projects_edit from '../pages/projects/edit.vue';
import projects_status from '../pages/projects/status.vue';
import projects_list from '../pages/projects/list.vue';

import awx_add from '../pages/awx/add.vue';
import awx_edit from '../pages/awx/edit.vue';
import awx_list from '../pages/awx/list.vue';

import jschemas_add from '../pages/jschemas/add.vue';
import jschemas_edit from '../pages/jschemas/edit.vue';
import jschemas_list from '../pages/jschemas/list.vue';


import Profile from '../pages/Profile.vue';

import Blacklist from '../pages/Blacklist.vue';

import SmtpInputList from '../pages/SmtpInput/list.vue';
import SmtpInputMessage from '../pages/SmtpInput/message.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        breadcrumb: [
          { name: 'Dashboard' }
        ]
      }
    },
    {
      path: '/mailbox',
      name: 'Mailbox',
      component: Mailbox,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', href: 'Dashboard' },
          { name: 'Mailbox' }
        ]
      }
    },
    {
      path: '/snackbar',
      name: 'Snackbar',
      component: Snackbar,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', href: 'Dashboard' },
          { name: 'Snackbar' }
        ]
      }
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', href: 'Dashboard' },
          { name: 'Calendar' }
        ]
      }
    },
    {
      path: '/social',
      name: 'Social',
      component: Social,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', href: 'Dashboard' },
          { name: 'Social' }
        ]
      }
    },
    {
      path: '/media',
      name: 'Media',
      component: Media,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', href: 'Dashboard' },
          { name: 'Media' }
        ]
      }
    },
    {
      path: '/chart',
      name: 'Chart',
      component: Chart,
      meta: {
        breadcrumb: [
          { name: 'Dashboard', href: 'Dashboard' },
          { name: 'Chart' }
        ]
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/error',
      name: 'Error',
      component: Error,
      meta: {
        allowAnonymous: true
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/blacklist',
      name: 'Blacklist',
      component: Blacklist,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/groups',
      name: 'Groups',
      component: groups_list,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/groups/add',
      name: 'Groups_add',
      component: groups_add,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/groups/edit/:id',
      name: 'Groups_edit',
      component: groups_edit,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/servers',
      name: 'ServersList',
      component: ServersList,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/servers/add',
      name: 'ServersAdd',
      component: ServersAdd,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/servers/edit/:id',
      name: 'ServersEdit',
      component: ServersEdit,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/servers/jobs/:id',
      name: 'ServersJobs',
      component: ServersJobs,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/instances',
      name: 'instances',
      component: instances_list,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/instances/add',
      name: 'instances_add',
      component: instances_add,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/instances/edit/:id',
      name: 'instances_edit',
      component: instances_edit,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/instances/jobs/:id',
      name: 'instances_jobs',
      component: instances_jobs,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/instances/status/:id',
      name: 'instances_status',
      component: instances_status,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/projects',
      name: 'projects',
      component: projects_list,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/projects/add',
      name: 'projects_add',
      component: projects_add,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/projects/edit/:id',
      name: 'projects_edit',
      component: projects_edit,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/projects/status/:id',
      name: 'projects_status',
      component: projects_status,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/awx',
      name: 'awx',
      component: awx_list,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/awx/add',
      name: 'awx_add',
      component: awx_add,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/awx/edit/:id',
      name: 'awx_edit',
      component: awx_edit,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/jschemas',
      name: 'jschemas',
      component: jschemas_list,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/jschemas/add',
      name: 'jschemas_add',
      component: jschemas_add,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/jschemas/edit/:id',
      name: 'jschemas_edit',
      component: jschemas_edit,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/smtpinput-list',
      name: 'SmtpInput',
      component: SmtpInputList,
      meta: {
        allowAnonymous: false
      }
    },
    {
      path: '/smtpinput-message/:id',
      name: 'smtpinput-message',
      component: SmtpInputMessage,
      meta: {
        allowAnonymous: false
      }
    },
  ]
});

router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login') {
    if (TokenService.hasAccessToken()) {
      if (!apiFactory.auth.checkProfileRole()) {
        apiFactory.auth.checkTokenAlive().then(response => {
          // if (response.data.check === 'allow') {}
          // if (response.data.check === 'deny') {}
          if (response.data.check === 'logout') {
            localStorage.clear();
            router.push('/login');
          }
        });
      }

      next();
    } else {
      next('login');
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js